import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrinterOutlined, ArrowLeftOutlined, DownloadOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import ExpenseRecordFilters from "./components/ExpenseRecordFilters";
import ExpenseRecordTable from "./components/ExpenseRecordTable";
import ExpenseRecordPrintView from "./components/ExpenseRecordPrintView";
import { useReactToPrint } from "react-to-print";
import { exportExpenseRecordCsv } from "./components/exportExpenseRecordCsv";

const { Title } = Typography;

const ExpenseRecord = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { message } = App.useApp();
  const {
    filters, list, details,
    filterResult, filterResultDetails,
  } = useSelector((state) => state.expenseRecord);

  const reportRef = useRef();

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Expense Record Report",
    removeAfterPrint: true,
  });

  const handleNavigateToReports = () => {
    navigate("/reports");
  };

                 const handleDownloadCsv = () => {
    exportExpenseRecordCsv({
      filters,
      details,
      filterResult,
      filterResultDetails,
      title:    "Expense Record",
      filename: "expense_record",
    });
  };

  const hasData =
    list.length > 0 || details.length > 0 ||
    filterResult.length > 0 || filterResultDetails.length > 0;

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              />
              <Title level={4} style={{ margin: 0 }}>Expense Record</Title>
            </div>
          }
            extra={
            hasData && (
              <Flex gap={8}>
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
                <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                  {!screens.xs && "Print"}
                </Button>
              </Flex>
            )
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        >
          <ExpenseRecordFilters messageApi={message} />
        </Card>

        <Card className="shadow-md rounded-xl">
          <ExpenseRecordTable />
        </Card>
      </App>

      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ExpenseRecordPrintView ref={reportRef} />
      </div>
    </div>
  );
};

export default ExpenseRecord;